<template>
  <div class="log-box">
    <div class="log-form">
      <div class="lgo-head">后台管理系统<br></div>
      <!-- form 表单校验 -->
      <div class="formBox">
        <el-form ref="Loginform" :model="form" :rules="rules" label-width="60px">
          <el-form-item prop="name">
            <el-input v-model="form.name" placeholder="请输入账号">
              <template #prefix>
                <el-icon>
                  <User />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input type="password" placeholder="请输入密码" v-model="form.pass" autocomplete="off">
              <template #prefix>
                <el-icon>
                  <Lock />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <div class="bot-box">
            <el-form-item prop="zymValue"> 
              <el-input  placeholder="请输入验证码" v-model="form.zymValue" autocomplete="off">
                <template #prefix>
                  <el-icon>
                    <Warning />
                  </el-icon>
                  <Yzm class="box-yzm" @yanzhengClick="yanzhengClick" ref="yzmCode"></Yzm>
                </template>
              </el-input>
              <!-- <div class=> -->
              <!-- <Yzm class="box-yzm" @yanzhengClick="yanzhengClick" ref="yzmCode"></Yzm> -->
              <!-- </div> -->
            </el-form-item>
          </div>

        </el-form>
        <el-button type="primary" @click="LoginClick('Loginform')">立即登录</el-button>
        <!-- <span class="zhanghaoStyle">输入密码账号后即可登录<i class="yonghuaStyle">用户隐私政策</i></span> -->
        <span class="zhanghaoStyle">输入密码账号后即可登录<i @click="userClick" class="yonghuaStyle">用户隐私政策</i></span>
      </div>
    </div>
    <UserText v-if="UserShow" @userBack="userBack"></UserText>
  </div>
</template>

<script>
import { User, Lock, Warning } from "@element-plus/icons-vue"; // 图标
// import HelloWorld from '@/components/HelloWorld.vue'
import { loginApi } from '@/assets/api/api'
import UserText from './userText/userAdd.vue'
import Yzm from './group/yzm.vue'
export default {
  name: 'log',
  components: {
    // HelloWorld
    User,
    Lock,
    Yzm,
    UserText,
    Warning
  },
  data() {
    return {
      UserShow:false,
      form: {
        name: '',
        pass: '',
        zymValue: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        zymValue: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    //打开隐私
    userClick(){
        this.UserShow = true
        console.log(1);
      },
      userBack(){
        this.UserShow =false
      },
    // 点击事件
    LoginClick(Loginform) {
      console.log(localStorage.getItem('imgCode'), this.form.zymValue);
      // // 验证码逻辑
      // if (this.form.zymValue.toLowerCase() == localStorage.getItem('imgCode').toLowerCase()) {
      //   console.log('验证码通过');
      // } else {
      //   console.log('验证失败',this.$refs.yzmCode);
      //   this.$message.error('验证码错误');
      //   this.$refs.yzmCode.handleDraw()
      // }

      this.$refs[Loginform].validate((valid) => {
        if (valid) {
          // return alert('校验通过')
          let params = {
            password: this.form.pass,
            username: this.form.name
          }
          loginApi(params).then((res) => {
            console.log(res, 77777);
            if (res.data.code === '1') {
              // console.log(123123);   
              this.$message({
                type: 'error',
                message: '登录失败，账号或密码不正确！'
              });
            }
            if (res.data.data.token) {
              this.$store.commit('tokenClick', res.data.data.token)
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('user', JSON.stringify(res.data.data.user))
              if (localStorage.getItem('token')) {
                this.$router.push({ path: '/custMatchResults' })
              }
            }
          }).catch((err) => {
            console.log(err, 999999);
          })
        } else {
          alert('校验失败')
          return false;
        }
      })
    },

  }
}

</script> 

<style lang='scss' scoped>
.log-box {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  position: relative;
  // background-image: url(./images/);
  background-image: url(./images/background.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .log-form {
    position: absolute;
    min-width: 600px;
    // height: 55%;
    min-height: 700px;
    left: 75%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 25px;
    padding: 55px 100px;

    .lgo-head {
      text-align: center;
      font-size: 30px;
      line-height: 45px;
      margin-bottom: 50px;
    }

    .zhanghaoStyle {
      font-size: 15px;
      color: #999999;
      margin-left: 65px;

      .yonghuaStyle {
        color: #348EFC;
      }

    }

    :deep() {
      #FAFAFB .el-input--small .el-input__wrapper {
        // border-color: #FAFAFB;
        // background-color: #FAFAFB;
      }

      .el-form-item__content {
        margin-left: 0 !important;
        margin-top: 20px;
        
        // margin-right: 16px !important;
      }

      .el-form-item--small .el-form-item__label {
        width: 60px !important;
      }

      .el-input--small .el-input__inner {
        height: 50px;
        font-size: 16px;
      }

      .el-form {
        margin-top: 30px;
        width: 100%;
      }

      .el-input--small {
        margin-bottom: 10px;
      }

      .el-button--small {
        width: 100%;
        // margin-left: 15px;
        height: 50px;
        // background-color: #0062FF;
        font-size: 16px;
        margin-top: 40px;
        border-radius: 8px;
        margin-bottom: 25px;

      }
    }
  }
}

.formBox {
  .bot-box {
    position: relative;
    :deep() {
      .el-input {
        width: 100%;
      }
    }

    .box-yzm {
      position: absolute;
      right: 0%;
      top: 50%;
      transform: translate(0,-50%);
    }
  }

  :deep() {
    .el-icon {
      color: #000;
      width: 20px;
      margin-right: 10px;
    }

    .el-icon svg {
      width: 35px;
      height: 25px;
    }
  }
}</style>
